import CurrencyTextField from '@core/components/Inputs/CurrencyTextField';
import React from 'react';

// FIXME: Esse componente foi realmente criado somente para chamar o outro componente? Validar se não é melhor chamar o <CurrencyTextField /> diretamente
const InputMonetario = ({
  id,
  name,
  label,
  handleBlur,
  handleChange,
  error,
  touched,
  helperText = 'Campo é obrigatório',
  value,
  maximumValue,
  fullWidth,
  required,
  disabled,
  autoFocus,
}) => {
  return (
    <CurrencyTextField
      variant="outlined"
      outputFormat="number"
      decimalCharacter=","
      digitGroupSeparator="."
      maximumValue={maximumValue || '99999999999'}
      fullWidth={fullWidth}
      autoFocus={autoFocus}
      id={id}
      name={name || id}
      label={label}
      decimalPlaces={2}
      decimalPlacesShownOnBlur={2}
      decimalPlacesShownOnFocus={2}
      onBlur={handleBlur}
      value={value}
      error={error && touched}
      helperText={error && touched && helperText}
      onChange={(e, val) => {
        handleChange({ target: { id, value: e.target.value ? val : undefined } });
      }}
      required={required}
      disabled={disabled}
    />
  );
};

export default InputMonetario;
